<template>
<div class="mobileApp itemlist">
    <div class="page_title"> 아이템 샵 </div>
    <div class="loading-spinner" v-if="isLoading">         
        <base-spinner></base-spinner>
    </div>
    <div class="item_list" v-if="!isLoading">       
        <div class="item_box" v-for="(item, index) in itemLists" :key="index">            
            <div class="item_head">
                <h1>{{item.title}}</h1>
                <!--<p>{{item.description}}</p>-->
            </div>
            <div class="item_img">
                <div v-if="item.image" :style="{backgroundImage:`url(/storage/${item.image})`}">           
                    <!-- <img :src="`/storage/${item.image}`"> -->
                </div>
                <div v-else class="blank_img">
                    {{item.title}}
                </div>
            </div>
            <div class="item_footer" :class="{point_item:item.price>0}">
                <h1 v-if="item.price>0">{{addCom(item.price)}} 원</h1>
                <h1 v-else>{{addCom(Math.abs(item.point))}} P</h1>
                <button @click="goItemBuy(item.id,'isMobile')">구매하기</button>
            </div>
        </div>
    </div>
</div>
   
</template>
<script>
import { itemList } from '@/components/mixins/pages/itemList'
export default {
    name:'mobile_ItemList',   
    mixins:[
        itemList
    ],    
   
}
</script>
<style lang="scss" scoped>
.itemlist{
    background:#fff;
    min-height: 100vh;
    .item_list
    {
        font-family:'Helvetica Neue',Arial,'맑은고딕',sans-serif;
        display:flex;
        flex-wrap:wrap;
    
        .item_box:hover{
            box-shadow: 0 10px 15px -3px rgba(0,0,0,.5),0 4px 6px -2px rgba(0,0,0,.5);
        }
        .item_box{
            box-shadow: 0 10px 15px -3px rgba(0,0,0,.1),0 4px 6px -2px rgba(0,0,0,.05);
            width: 45%;
            overflow: hidden;
            margin: 0.5rem;
            border-radius: .5rem;
            background-color: #fff;
            .item_head{
                padding-left: 1rem;
                padding-right: 1rem;
                padding-top: .5rem;
                padding-bottom: .5rem;                
                background: #e9e9e9;  
                height: 46px;
                display: flex;
                justify-content: center;
                align-items: center;
                h1{
                    font-size: .7rem;
                    color: #1a202c;
                    font-weight: 700;
                    margin: 0;
                }
                p{
                    color: #718096;
                    font-size: .8rem;
                    margin-top: .25rem;
                }
            }
            .item_img{
                height: 12rem;
                overflow:hidden;
                div{
                    height:100%;
                    background: center;
                    background-size:cover;
                }
                img{
                    width:100%;
                }
                .blank_img{
                    background:black;
                    height:100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 1rem;
                    color: #edf2f7;
                    font-weight: 700;
                }
            }
            .item_footer{
                padding-left: 1rem;
                padding-right: 1rem;
                padding-top: .5rem;
                padding-bottom: .5rem;
                display: flex;
                justify-content: space-between;
                align-items: center;
                background-color: #1a202c;
                height:35px;
                h1{
                    font-size: 1rem;
                    color: #edf2f7;
                    font-weight: 700;
                    margin:0;
                }
                button{
                    font-size: .7rem;
                    color: #1a202c;
                    padding-left: .75rem;
                    padding-right: .75rem;
                    padding-top: .25rem;
                    padding-bottom: .25rem;
                    font-weight: 600;
                    border-radius: .25rem;
                    background-color: #edf2f7;
                    cursor: pointer;
                    line-height: inherit;
                    border-width: 0;
                }
            }
            .point_item{
                background:#5a001a;
            }
        }
    }
}

</style>